import React, { FC, useState } from "react";
import { useApplicationData } from "contexts/ApplicationDataContext";
import { ATMAccordion } from "components/atoms/ATMAccordion/ATMAccordion.component";
import { ATMSegment } from "components/atoms/ATMSegment/ATMSegment.component";
import SecurityIcon from '@mui/icons-material/Security';
import styles from "./TermsAndConditions.module.scss";
import { ATMGrid } from "components/atoms/ATMGrid/ATMGrid.component";
import { ATMHeader } from "components/atoms/ATMHeader/ATMHeader.component";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { ATMButton } from "components/atoms/ATMButton/ATMButton.component";
import { ModeEdit } from "@mui/icons-material";
import { ATMDivider } from "components/atoms/ATMDivider/ATMDivider.component";
import { ATMField } from "components/atoms/ATMField/ATMField.component";
import { FormField } from "semantic-ui-react";
import { CustomCheckbox } from "components/CustomCheckBox/CustomCheckBox.component";
import { applicationData } from "contexts/applicationDataFieldTypes";




interface TermsAndConditionsProps {
    applicationData: applicationData;
    setApplicationData: React.Dispatch<React.SetStateAction<applicationData>>;
    checkedTermsAndConditions: boolean;
    setCheckedTermsAndConditions: React.Dispatch<React.SetStateAction<boolean>>;
    toggle: boolean;
    setToggle: (value: boolean) => void;
    control: any;
    /** Legacy fumFLblTermsCondMessage — empty when the box is checked. */
    termsError?: string;
    sectionRef?: React.RefObject<HTMLDivElement>;
}

const TermsAndConditions: React.FC<TermsAndConditionsProps> = ({ applicationData, setApplicationData, checkedTermsAndConditions, setCheckedTermsAndConditions, toggle, setToggle, control, termsError = '', sectionRef }) => {


    //const { checkedTermsAndCondtions, setCheckedTermsAndConditions } = useApplicationData();


    const handleToggle = () => {
        setToggle(!toggle);
    }

    return (
        <div ref={sectionRef}>
            <ATMSegment size="tiny" className={styles.commonMargin}>
                <ATMGrid>
                <ATMGrid.Row>
                    <ATMGrid.Column
                        width={8}
                        className={styles.segmentsStyle}
                        onClick={handleToggle}
                    >
                        <ATMHeader as="h2" className={styles.headerStyle}>
                            <SecurityIcon />
                            {"Terms and Conditions"}
                        </ATMHeader>
                    </ATMGrid.Column>

                    {!!toggle ? (
                        (
                            <ATMGrid.Column
                                width={8}
                                floated="right"
                                textAlign="right"
                                onClick={handleToggle}
                            >
                                <ExpandLess />
                            </ATMGrid.Column>
                        )
                    ) : (
                        <ATMGrid.Column
                            width={8}
                            floated="right"
                            textAlign="right"
                            onClick={handleToggle}
                        >
                            <ExpandMore />
                        </ATMGrid.Column>
                    )}

                </ATMGrid.Row>
            </ATMGrid>




            {

                toggle && (
                    <>
                        {

                            <ATMGrid className={styles.gridStyle}>
                                <ATMDivider className={styles.divider} />
                                <ATMGrid.Row>
                                    <ATMGrid.Column
                                        className="sempraMediumMarginBottom"
                                    >
                                        <span className={styles.declarationStatement}>
                                            {"Declaration Statement: "}
                                        </span>
                                        <span className={styles.declarationText}>
                                            {

                                                "I state that the information I have provided on this form is true and correct."
                                                + "Fumigation contractors are responsible for ensuring utility company has proper meter access to complete the order(s) requested."
                                                + "Restores require meter access and access into each home/unit/building in order to service gas appliances. Inability to access the gas meter (e.g., locked gates, dogs, etc.) and/or appliances"
                                            }
                                        </span>

                                        <span className={styles.declarationStatement}>
                                            {" will result in a delay and/or cancellation of your order."}

                                        </span>

                                        <span className={styles.declarationText}>

                                            {" If a request is made to cancel an existing fumigation close order, the corresponding fumigation Back-On order, if any, will be automatically cancelled."}
                                        </span>


                                    </ATMGrid.Column>
                                </ATMGrid.Row>

                                <ATMGrid.Row>
                                    <ATMGrid.Column
                                        className="sempraMediumMarginBottom"
                                    >
                                        <FormField style={{ marginBottom: '0.5rem' }}>
                                            <ATMField
                                                as={CustomCheckbox}
                                                //disabled
                                                className={
                                                    styles[
                                                    'checkBoxField'
                                                    ]
                                                }
                                                value={checkedTermsAndConditions}
                                                name={"I agree to the Terms and Conditions."}
                                                label={"I agree to the Terms and Conditions."}
                                                onChange={(e: any) => setCheckedTermsAndConditions(!checkedTermsAndConditions)}
                                                autoComplete="off"
                                            />
                                        </FormField>

                                        {termsError && (
                                            <div
                                                role="alert"
                                                style={{
                                                    fontSize: '13px',
                                                    fontFamily: 'Arial, Helvetica, sans-serif',
                                                    border: '1px solid #A11003',
                                                    borderLeft: '4px solid #A11003',
                                                    borderRadius: '4px',
                                                    background: '#FDF3F2',
                                                    padding: '10px 14px',
                                                    marginTop: '8px',
                                                    color: '#A11003',
                                                    fontWeight: 'bold',
                                                }}
                                            >
                                                {termsError}
                                            </div>
                                        )}


                                    </ATMGrid.Column>
                                </ATMGrid.Row>


                            </ATMGrid>

                        }

                    </>
                )
            }

        </ATMSegment>
        </div>
    );
}

export default TermsAndConditions;